import { render } from "./SiteMenuTrigger.vue?vue&type=template&id=83963ba2&scoped=true"
import script from "./SiteMenuTrigger.vue?vue&type=script&lang=js"
export * from "./SiteMenuTrigger.vue?vue&type=script&lang=js"

import "./SiteMenuTrigger.vue?vue&type=style&index=0&id=83963ba2&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83963ba2"]])

export default __exports__